module.exports = __webpack_public_path__ + "media/fonts/material-design-icons/materialdesignicons-webfont-3584b5e5ae0c251ea23760f6a50b3eec.eot";